// extracted by mini-css-extract-plugin
export default {"label":"styles_label__eV5Vg","error":"styles_error__cPwR+","checkbox":"styles_checkbox__ArfEl"};